"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBusinessEmailServiceURL = exports.getServerURL = void 0;

var getServerURL = function getServerURL() {
  // Returns the backend server URL, always with a slash at the end
  var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL || '';

  if (!url.endsWith('/')) {
    url += '/';
  }

  return url;
};

exports.getServerURL = getServerURL;

var getBusinessEmailServiceURL = function getBusinessEmailServiceURL(businessType, businessId) {
  return "".concat(getServerURL(), "businesses/").concat(businessType, "s/").concat(businessId, "/email/");
};

exports.getBusinessEmailServiceURL = getBusinessEmailServiceURL;